import { useQuery } from '@tanstack/react-query'
import { billingService, type UsageResponse } from '@/services/billing'

export const BILLING_USAGE_KEY = 'billingUsage'

/**
 * Billing usage for the current org. Shared query key so the navbar pill, the
 * gate, and any other consumer collapse to a single /billing/usage request
 * instead of firing it once each. Returns null on error/while loading — callers
 * already treat "no usage" as "don't render".
 */
export function useBillingUsage(orgSlug: string | undefined): UsageResponse | null {
  const { data } = useQuery({
    queryKey: [BILLING_USAGE_KEY, orgSlug],
    queryFn: () => billingService.getUsage(),
    enabled: !!orgSlug,
  })

  return data ?? null
}
